export default {
  path: '/2019LJFL',
  name: '2019LJFL',
  component: () => import('./Home.vue'),
  redirect: '/2019LJFL/rules',
  meta: {
    title: '重庆市垃圾分类时尚小区暨最美社区游园',
  },
  children: [
    // {
    //   path: 'givelike',
    //   component: () => import('./GiveLike.vue'),
    //   name: 'VoteForgivelike',
    //   meta: {
    //     title: '重庆市垃圾分类时尚小区暨最美社区游园',
    //   },
    // },
    {
      path: 'give-like',
      component: () => import('./GiveLike.vue'),
      name: 'LJFLgive-like',
      meta: {
        title: '重庆市垃圾分类时尚小区暨最美社区游园',
      },
    },
    {
      path: 'likerules',
      component: () => import('./LikeRules.vue'),
      name: 'LJFLLikeRules',
      meta: {
        title: '重庆市垃圾分类时尚小区暨最美社区游园',
      },
    },
    {
      path: 'rules',
      component: () => import('./Introduction.vue'),
      name: 'LJFLrules',
      meta: {
        title: '重庆市垃圾分类时尚小区暨最美社区游园',
      },
    },
    {
      path: 'news',
      component: () => import('./RelatedNews.vue'),
      name: 'LJFLnews',
      meta: {
        title: '重庆市垃圾分类时尚小区暨最美社区游园',
      },
    },
    {
      path: 'detail',
      component: () => import('./DetailPage.vue'),
      name: 'LJFLdetail',
      meta: {
        title: '重庆市垃圾分类时尚小区暨最美社区游园',
      },
    },
    {
      path: 'coin-record',
      component: () => import('./CoinRecord.vue'),
      name: 'LJFLcoin-record',
      meta: {
        title: '重庆市垃圾分类时尚小区暨最美社区游园',
      },
    },
  ],
};
